import { useGetPresentations } from "../../../../../hooks/api/useGetPresentations";
import React, { useMemo, useRef, useState } from "react";
import { PresentationsPage, PresentationsWrapper, PresentationsWrapperEmpty } from "./styles";
import { SelectablePresentation } from "./components/selectablePresentation";
export var CoursePresentationEditBlock = function (props) {
    var _a;
    var onSelect = props.onSelect, selectedProject = props.selectedProject;
    var _b = useGetPresentations(), projects = _b.projects, loading = _b.loading;
    var _c = useState(false), isMouseDown = _c[0], setIsMouseDown = _c[1];
    var _d = useState(0), startX = _d[0], setStartX = _d[1];
    var _e = useState(0), startY = _e[0], setStartY = _e[1];
    var _f = useState(0), scrollLeft = _f[0], setScrollLeft = _f[1];
    var _g = useState(0), scrollTop = _g[0], setScrollTop = _g[1];
    var wrapperRef = useRef(null);
    var splittedProjects = useMemo(function () {
        if (!projects || (projects === null || projects === void 0 ? void 0 : projects.length) === 0)
            return [];
        var slicedProjects = [];
        for (var i = 0; i < (projects === null || projects === void 0 ? void 0 : projects.length); i += 9) {
            slicedProjects.push(projects === null || projects === void 0 ? void 0 : projects.slice(i, i + 9));
        }
        return slicedProjects;
    }, [projects]);
    var wrapperWidth = useMemo(function () { var _a; return (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) ? (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth : 0; }, [wrapperRef, (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth]);
    var handleMouseDown = function (e) {
        if (!wrapperRef.current)
            return;
        setIsMouseDown(true);
        setStartX(e.pageX);
        setStartY(e.pageY);
        setScrollLeft(wrapperRef.current.scrollLeft);
        setScrollTop(wrapperRef.current.scrollTop);
    };
    var handleMouseLeave = function () {
        setIsMouseDown(false);
    };
    var handleMouseUp = function () {
        setIsMouseDown(false);
    };
    var handleMouseMove = function (e) {
        if (!isMouseDown)
            return;
        if (!wrapperRef.current)
            return;
        var x = e.pageX;
        var y = e.pageY;
        var walkX = (x - startX);
        var walkY = (y - startY);
        wrapperRef.current.scrollLeft = scrollLeft - walkX;
        wrapperRef.current.scrollTop = scrollTop - walkY;
    };
    if (!loading && ((projects === null || projects === void 0 ? void 0 : projects.length) === 0 || !projects))
        return React.createElement(PresentationsWrapperEmpty, null, "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0446\u0438\u0439");
    return React.createElement(PresentationsWrapper, { onMouseDown: handleMouseDown, onMouseLeave: handleMouseLeave, onMouseUp: handleMouseUp, onMouseMove: handleMouseMove, ref: wrapperRef }, splittedProjects === null || splittedProjects === void 0 ? void 0 : splittedProjects.map(function (projects, index) { return React.createElement(PresentationsPage, { width: wrapperWidth, key: index }, projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return React.createElement(SelectablePresentation, { key: project === null || project === void 0 ? void 0 : project.projectId, project: project, selected: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.includes(project === null || project === void 0 ? void 0 : project.projectId), onSelect: function () { return onSelect(project === null || project === void 0 ? void 0 : project.projectId); } }); })); }));
};
//# sourceMappingURL=CoursePresentationEditBlock.js.mapimport { useGetPresentations } from "../../../../../hooks/api/useGetPresentations";
import React, { useMemo, useRef, useState } from "react";
import { PresentationsPage, PresentationsWrapper, PresentationsWrapperEmpty } from "./styles";
import { SelectablePresentation } from "./components/selectablePresentation";
export var CoursePresentationEditBlock = function (props) {
    var _a;
    var onSelect = props.onSelect, selectedProject = props.selectedProject;
    var _b = useGetPresentations(), projects = _b.projects, loading = _b.loading;
    var _c = useState(false), isMouseDown = _c[0], setIsMouseDown = _c[1];
    var _d = useState(0), startX = _d[0], setStartX = _d[1];
    var _e = useState(0), startY = _e[0], setStartY = _e[1];
    var _f = useState(0), scrollLeft = _f[0], setScrollLeft = _f[1];
    var _g = useState(0), scrollTop = _g[0], setScrollTop = _g[1];
    var wrapperRef = useRef(null);
    var splittedProjects = useMemo(function () {
        if (!projects || (projects === null || projects === void 0 ? void 0 : projects.length) === 0)
            return [];
        var slicedProjects = [];
        for (var i = 0; i < (projects === null || projects === void 0 ? void 0 : projects.length); i += 9) {
            slicedProjects.push(projects === null || projects === void 0 ? void 0 : projects.slice(i, i + 9));
        }
        return slicedProjects;
    }, [projects]);
    var wrapperWidth = useMemo(function () { var _a; return (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) ? (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth : 0; }, [wrapperRef, (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth]);
    var handleMouseDown = function (e) {
        if (!wrapperRef.current)
            return;
        setIsMouseDown(true);
        setStartX(e.pageX);
        setStartY(e.pageY);
        setScrollLeft(wrapperRef.current.scrollLeft);
        setScrollTop(wrapperRef.current.scrollTop);
    };
    var handleMouseLeave = function () {
        setIsMouseDown(false);
    };
    var handleMouseUp = function () {
        setIsMouseDown(false);
    };
    var handleMouseMove = function (e) {
        if (!isMouseDown)
            return;
        if (!wrapperRef.current)
            return;
        var x = e.pageX;
        var y = e.pageY;
        var walkX = (x - startX);
        var walkY = (y - startY);
        wrapperRef.current.scrollLeft = scrollLeft - walkX;
        wrapperRef.current.scrollTop = scrollTop - walkY;
    };
    if (!loading && ((projects === null || projects === void 0 ? void 0 : projects.length) === 0 || !projects))
        return React.createElement(PresentationsWrapperEmpty, null, "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0446\u0438\u0439");
    return React.createElement(PresentationsWrapper, { onMouseDown: handleMouseDown, onMouseLeave: handleMouseLeave, onMouseUp: handleMouseUp, onMouseMove: handleMouseMove, ref: wrapperRef }, splittedProjects === null || splittedProjects === void 0 ? void 0 : splittedProjects.map(function (projects, index) { return React.createElement(PresentationsPage, { width: wrapperWidth, key: index }, projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return React.createElement(SelectablePresentation, { key: project === null || project === void 0 ? void 0 : project.projectId, project: project, selected: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.includes(project === null || project === void 0 ? void 0 : project.projectId), onSelect: function () { return onSelect(project === null || project === void 0 ? void 0 : project.projectId); } }); })); }));
};
//# sourceMappingURL=CoursePresentationEditBlock.js.map